<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      :visible.sync="modalVisible"
      :contentStyle="{'height': '100%'}"
      size="650_auto"
      :confirm-loading="confirmLoading"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>
      <span>企业信息</span>
    </template>

    <template #content>
      <el-form
          class="warning-form"
          ref="form"
          :model="form"
          :rules="formRule"
          label-width="100px">
        <el-form-item label="企业名称" prop="companyName">
          <gj-input
            v-model="form.companyName"
            :clearable="false"
            width="100%"
            placeholder="请输入企业名称"
          ></gj-input>
        </el-form-item>
        <el-form-item label="国家" prop="country">
          <gj-input
            v-model="form.country"
            :clearable="false"
            width="100%"
            placeholder="请输入国家"
          ></gj-input>
        </el-form-item>
        <el-form-item label="州/省" prop="province">
          <gj-input
            v-model="form.province"
            :clearable="false"
            width="100%"
            placeholder="请输入州/省"
          ></gj-input>
        </el-form-item>
        <el-form-item label="城市" prop="city">
          <gj-input
            v-model="form.city"
            :clearable="false"
            width="100%"
            placeholder="请输入城市"
          ></gj-input>
        </el-form-item>
        <el-form-item label="邮编" prop="postCode">
          <gj-input
            v-model="form.postCode"
            :clearable="false"
            width="100%"
            placeholder="请输入邮编"
          ></gj-input>
        </el-form-item>
        <el-form-item label="详细地址" prop="addr">
          <gj-textarea
            v-model="form.addr"
            :clearable="false"
            :styles="{height: '120px', width: '100%'}"
            placeholder="请输入详细地址"
          ></gj-textarea>
        </el-form-item>
        <el-form-item label="上传订单类型" prop="uploadType">
          <el-radio-group v-model="form.uploadType">
            <el-radio label="all">所有订单</el-radio>
            <el-radio label="b2b">企业订单（B2B）</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
import {formRuleMixin, modalMixIn} from "@/minxins";
import { isMeaningful } from "@/utils/common";
import { vatInvoiceEdit } from "@/api/vat"
export default {
  name: "app-vat-edit-modal",
  mixins: [modalMixIn, formRuleMixin],
  props: {
    item: {
      required: true
    },
  },

  data() {
    return {
      confirmLoading: false,
      form: {
        companyName: '',
        country: '',
        province: '',
        city: '',
        postCode: '',
        addr: '',
        uploadType: ''
      },
      formRule: {
        companyName: [{
          required: true,
          message: '请输入企业名称',
          trigger: ['blur','change']
        }],
        country: [{
          required: true,
          message: '请输入国家',
          trigger: ['blur','change']
        }],
        province: [{
          required: true,
          message: '请输入州/省',
          trigger: ['blur','change']
        }],
        city: [{
          required: true,
          message: '请输入城市',
          trigger: ['blur','change']
        }],
        postCode: [{
          required: true,
          message: '请输入邮编',
          trigger: ['blur','change']
        }],
        uploadType: [{
          required: true,
          message: '请选择上传订单类型',
          trigger: 'change'
        }]
      },
      oldData: null
    }
  },

  created() {
    if (isMeaningful(this.item)) {
      this.form.id = this.item.id;
      this.form.marketId = this.item.marketId;
      this.form.companyName = this.item.companyName;
      this.form.country = this.item.country;
      this.form.province = this.item.province;
      this.form.city = this.item.city;
      this.form.postCode = this.item.postCode;
      this.form.addr = this.item.addr;
      this.form.uploadType = this.item.uploadType;
      this.oldData = this._.cloneDeep(this.item)
    }
  },

  methods: {
    // 提交
    async confirm() {
      if (this.$gjFormValidate()) {
        if (!this.judgeChange()) {
          this.$gjDestroy();
          return false;
        }

        // 编辑所传参数
        const params = {
          ...this.form
        }

        // 调用编辑接口
        this.confirmLoading = true;
        try {
          const {data} = await vatInvoiceEdit(params);
          if (data) {
            this.$gjMessage.success('修改成功');
            this.$emit('updated', data);
            this.$gjDestroy();
          }
        } finally {
          this.confirmLoading = false;
        }
      }
    },
    //  判断数据是否发生改变
    judgeChange() {
      // 先把form克隆下来，一面form发生变化
      let params = this._.cloneDeep(this.form);
      let flag
      for (let key in params) {
        if (params[key] != this.oldData[key]) {
          flag = true
        }
      }
      return flag
    }
  }
}
</script>
